<h2 mat-dialog-title>
  Informacion evento
</h2>









<mat-dialog-content class="mat-typography row  d-flex justify-content-center">

  <p class="card-title no-margin col-12 text-center ">
    Horarios <br>
    {{data.dateStart | date : 'dd/MM/yyyy, h:mm a'}}
    <br>
    {{data.dateEnd | date : 'dd/MM/yyyy, h:mm a'}}


  </p>


  <p class="card-title mt-3 col-12 text-center ">
    Dirección <br>

    <a href="https://www.google.cl/maps/search/{{data.address}}" target="_blank">
      <h5 style="margin-bottom: 0px;" class="text-truncate-2-line">{{data.address}}</h5>
    </a>


    <br>
    {{data.commune}}
    <br>
    {{data.region}}



  </p>

  <div class="col-12 row d-flex justify-content-center text-center no-padding mb-3 mt-3">
    <div style="width: 100%;text-align: justify;" class="col-12" [innerHTML]="byPassHTML(data.desc!)">
    </div>
  </div>



</mat-dialog-content>



<mat-dialog-actions align="end">

  <button mat-button type="button" (click)="closeDialog(false)">Cerrar</button>
</mat-dialog-actions>